import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";
import type { ShipmentCheckCall } from "~/shared/schemas/shipment-management-schema.ts";

import { getEnteredByLabel } from "../../../utils/get-entered-by-label.ts";

type DeleteTrackingMessageModalProps = {
	readonly checkCall: ShipmentCheckCall;
	readonly onClose: () => void;
	readonly onConfirm: () => void;
};

export const DeleteTrackingMessageModal = ({
	checkCall,
	onClose,
	onConfirm,
}: DeleteTrackingMessageModalProps) => {
	const enteredBy = getEnteredByLabel(checkCall.enteredBy);

	return (
		<TraxModal
			confirmText={"Yes, Delete"}
			onCancel={onClose}
			onClose={onClose}
			onConfirm={onConfirm}
			title={"Delete Tracking Message"}
			type={"confirmation"}
		>
			<p>
				Are you sure you want to delete this tracking message
				{enteredBy ? (
					<>
						{" "}
						from <strong>{enteredBy.label}</strong>
					</>
				) : null}
				?
			</p>
		</TraxModal>
	);
};
